var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',[_c('b-row',{attrs:{"id":"rssFeedManagmenet"}},[_c('b-col',{staticClass:"shadow-sm"},[_c('h4',{staticClass:"card-title font-weight-bold"},[_vm._v("\n        Rss-Feed Verwaltung\n      ")]),_c('b-card-body',[_c('b-row',[_c('RssFeedManagement',{staticClass:"w-100"})],1)],1)],1)],1),_c('div',{staticStyle:{"height":"500px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }